/**
 * Merkt sich pro User den `users/{uid}/claimsUpdatedAt`-Stempel, fuer den der
 * ID-Token bereits einmal forced nachgeladen wurde (`AuthService.onDbUserChanged`,
 * `_whocan-info/product/workorder-idtoken-refresh-signal-2026-09-16.md`).
 *
 * Warum persistent und nicht nur im Speicher: `issuedAtTime` des Tokens hat
 * Sekunden-Granularitaet, der Stempel Millisekunden. Faellt der forced Refresh in
 * dieselbe Sekunde wie der Stempel (Regelfall: der Refresh folgt dem Stempel um
 * einige hundert ms), sieht das frische Token beim naechsten App-Start aelter aus
 * als der Stempel und wuerde ein zweites Mal forced geladen - genau der
 * securetoken-Traffic, den das Signal einsparen soll.
 *
 * Bewusst framework-frei (kein Angular-Import), analog `auth-state-storage.ts`.
 */

const KEY_PREFIX = 'whocan.claimsRefreshedAt.';

/** localStorage kann werfen (Safari Private Mode, deaktivierte Cookies) - dann 0 = nichts gemerkt. */
export function readClaimsRefreshedAt(uid: string): number {
    try {
        return Number(window.localStorage.getItem(KEY_PREFIX + uid)) || 0;
    } catch (e) {
        return 0;
    }
}

export function writeClaimsRefreshedAt(uid: string, stamp: number): void {
    try {
        window.localStorage.setItem(KEY_PREFIX + uid, String(stamp));
    } catch (e) {
        // Ohne Speicher deckt der In-Memory-Wert im AuthService die laufende Session ab.
    }
}
